var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"10","height":"17","viewBox":"0 0 10 17","fill":"#495D7B","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.014 16.029L0 8.014 8.014 0 10 1.986 3.971 8.014 10 14.043l-1.986 1.986z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }